import { render } from "./UsersModal.vue?vue&type=template&id=4f4b3281&scoped=true"
import script from "./UsersModal.vue?vue&type=script&lang=js"
export * from "./UsersModal.vue?vue&type=script&lang=js"

import "./UsersModal.vue?vue&type=style&index=0&id=4f4b3281&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4b3281"]])

export default __exports__